import React from 'react';

import { Skeleton, SkeletonBar } from 'wanderu-animations';
import { Card } from 'wanderu-components';

import styles from './TripCardSkeleton.scss';

export const TripCardSkeleton = () => {
    return (
        <Card
            className={styles.container}
            elevation={2}
        >
            <Skeleton className={styles.row}>
                <SkeletonBar className={styles.price} />
                <SkeletonBar className={styles.tripModes} />
            </Skeleton>
            <Skeleton className={styles.summary}>
                <SkeletonBar className={styles.bar} />
                <SkeletonBar className={styles.bar} />
            </Skeleton>
            <Skeleton className={styles.endpoints}>
                <Skeleton className={styles.departEndpoint}>
                    <SkeletonBar className={styles.bar} />
                    <SkeletonBar className={styles.bar} />
                </Skeleton>
                <Skeleton className={styles.arriveEndpoint}>
                    <SkeletonBar className={styles.bar} />
                    <SkeletonBar className={styles.bar} />
                </Skeleton>
            </Skeleton>
            <SkeletonBar className={styles.button} />
        </Card>
    );
};
